import React, {Component} from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import shallowCompare from 'react-addons-shallow-compare'
import {Link} from 'react-router'
import IdeaOwner from '../components/IdeaOwner'
import RecommendationLabel from '../components/RecommendationLabel'
import {Label} from 'react-bootstrap'
import './css/CompactListItem.css' //TODO: extract the one we use here
import { Glyphicon } from 'react-bootstrap'
import './css/DashboardIdeaItem.css'

class DashboardIdeaItem extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }
  render() {
    const { row, rowStyle, connectDragSource, connectDropTarget, isDragging } = this.props

    const itemContainerClass = classnames({
      'ItemContainer': true,
      'ItemPlaceholder': isDragging,
    })
    const tags = row.tags ? row.tags : []

    return connectDragSource(connectDropTarget(
      <div className='ItemWrapper' style={rowStyle}>
        <Link style={{textDecoration: 'none',color: 'black'}} to={{ pathname: '/idea/'+ row.id + '/view' }}>
          <div style={{border: row.border, WebkitBoxShadow: row.boxShadow, backgroundColor: row.color}} className={itemContainerClass}>
            <div style={{marginBottom: 10+'px'}} className='ItemContent'>
              <div style={{overflow: 'auto'}}>
                {row.showOwner &&
                  <div className='dashOwnerImage'>
                  {row.responsible === undefined &&
                    <IdeaOwner
                        ownerName={row.ownerName}
                        ownerPhotoURL={row.ownerPhotoURL}
                    />
                  }
                  {row.responsible !== undefined &&
                    <IdeaOwner
                        ownerName={row.responsible.fullName}
                        ownerPhotoURL={row.responsible.photoURL}
                    />
                  }
                  </div>
                }
                <div className='dashIdeaName'>
                  <p>{row.name}</p>
                </div>
              </div>
              <div style={{width: 100+'%'}}>
              {row.showTeamSize && 
                <div style={{display: 'inline-block', paddingTop: 3+'px', marginRight: 5+'px'}}>
                  <div style={{color: '#929292'}}>{row.teamSize}<Glyphicon style={{marginLeft: 2+'px', marginTop: 5+'px', color: '#ed1558'}} glyph='user'/></div>
                </div> 
              }
              {row.showRec &&
                <div className='dashRecommendation' style={{display: 'inline-block'}}>
                  <RecommendationLabel 
                    effortRating={row.effortRating} 
                    impactRating={row.impactRating}
                  />
                </div>
              }
              </div>
              {row.imageUrl && row.showImage &&
                  <img src={row.imageUrl} style={{objectFit: 'cover', marginTop: 10+'px'}} alt={row.name} width={100+'%'} height={200}/>
              }
              <div style={{maxWidth: 95+'%', marginTop: 5+'px'}}>
                {row.showTags && tags.map((tag, index) =>
                  <span style={{display: 'inline-block'}} className='tagSize' key={index}><Label bsStyle='primary'>{tag}</Label></span>,
                )}
              </div>
              <div className='dashExtraInfo'>
                {(row.showStage || row.showCreationDate || row.showLastUpdated) &&
                  <div className='dashLine'/>
                }
                {row.showStage &&
                  <div className='additionalInfo'>Stage: <strong >{row.currentStage}</strong></div>
                }
                {row.showCreationDate &&
                  <div className='additionalInfo'>Creation date: <strong >{row.timestamp}</strong></div>
                }
                {(row.showDueDate && row.dueDate && row.dueDate !== '') &&
                  <div className='additionalInfo'>Due date: <strong>{row.dueDate}</strong></div>
                }
                {row.showLastUpdated &&
                  <div className='additionalInfo'>Last updated: <strong>{row.lastUpdated}</strong></div>
                }
              </div>
            </div>
          </div>
        </Link>
      </div>,
    ))
  }
}

DashboardIdeaItem.propTypes = {
  row: PropTypes.object.isRequired,
  rowId: PropTypes.string.isRequired,
  listId: PropTypes.string.isRequired,
  isDragging: PropTypes.bool.isRequired,
  rowStyle: PropTypes.object.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,  
}

export default DashboardIdeaItem



// WEBPACK FOOTER //
// ./src/components/DashboardIdeaItem.js